import { ViewIds, type Feature } from '@ardoq/api-types';
import {
  Features,
  featureOperations,
  type FeatureContext,
} from '@ardoq/features';

const VIEW_CONVERSION_FEATURES: [ViewIds, Feature][] = [
  [ViewIds.DEPENDENCY_MAP_2, Features.CONVERT_SLIDES_TO_VIEWPOINT],
  [ViewIds.RELATIONSHIPS_3, Features.CONVERT_SLIDES_TO_VIEWPOINT],
];

/** The views whose workspace-mode slides the organization converts. */
export const getEnabledViewsToConvert = (
  featureContext: FeatureContext
): ViewIds[] =>
  VIEW_CONVERSION_FEATURES.filter(([, feature]) =>
    featureOperations.hasFeature(featureContext, feature)
  ).map(([viewId]) => viewId);

/**
 * The views whose workspace-mode slides the presentation build should convert
 * to viewpoint mode, or null for an anonymous viewer, whose features are
 * unknown, to leave it to the organization's.
 */
export const getViewsToConvert = (
  isSignedIn: boolean,
  featureContext: FeatureContext
): ViewIds[] | null => {
  if (!isSignedIn) return null;
  return getEnabledViewsToConvert(featureContext);
};
